import React from 'react';
import { CheckIcon } from 'lucide-react';
import { RevealOnScroll } from './RevealOnScroll';
const items = ['Te despiertas empapada en sudor varias veces por noche', 'Sientes que subes de peso aunque comas igual que antes', 'Cambios de humor que ni tú reconoces', 'Cansancio que no se quita ni durmiendo 8 horas', 'Te sientes invisible, irritable, "no eres tú misma"'];
export function ProblemSection() {
  return <section className="w-full bg-white px-5 py-10 md:py-16" aria-labelledby="problem-heading" data-id="element-174">
      <div className="mx-auto max-w-container" data-id="element-175">
        <h2 id="problem-heading" className="font-serif text-[24px] font-medium text-wine md:text-[28px]" data-id="element-176">
          ¿Te identificas con esto?
        </h2>
        <p className="mt-2 text-[14px] text-rose" data-id="element-177">
          Si marcas 3 o más, esta guía es para ti
        </p>

        <ul className="mt-6 flex flex-col gap-3" data-id="element-178">
          {items.map((item, i) => <RevealOnScroll key={i} delay={i * 0.05} data-id="element-179">
              <li className="flex items-start gap-3 rounded-[12px] bg-cream p-3 md:p-4" data-id="element-180">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-pinkLight" aria-hidden="true" data-id="element-181">
                  <CheckIcon size={14} className="text-rose" strokeWidth={3} data-id="element-182" />
                </span>
                <span className="text-[14px] leading-[1.55] text-wine" data-id="element-183">
                  {item}
                </span>
              </li>
            </RevealOnScroll>)}
        </ul>
      </div>
    </section>;
}